export const titleCase = (value) => {
    if (!value || value.length === 0)
        return '';
    let words = value.replaceAll('_', ' ').split(' ');
    for (let i in words) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1).toLowerCase();
    }
    return words.join(' ');
};
